import React, { FC } from "react";
export const Terms: FC = () => (
  <section style={{ maxWidth: 1000, padding: "2em", margin: "auto" }}>
    <p className="p1">
      <span className="s1">
        <strong>Terms of Use</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        These Terms and Conditions of Use (the &ldquo;Terms of Use&rdquo;) apply
        to our website located www.celestion.com (our site) and all associated
        sites and apps linked to our site by GP Acoustics (UK) Limited.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS SITE. THESE
        TERMS OF USE MAY HAVE CHANGED SINCE YOUR LAST VISIT TO THE SITE. YOUR
        CONTINUED USE OF THE SITE CONSTITUTES YOUR ACCEPTANCE OF ANY CHANGES
        MADE TO THESE TERMS OF USE.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Who we are and how to contact us</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        www.celestion.com (our site) is a site operated by GP Acoustics (UK)
        Limited ("We"). We are registered in England and Wales under company
        number 02711002 and have our registered office at Business Unit 111,
        Claydon Business Park, Great Blakenham, Ipswich, Suffolk IP6 0NL Park,
        Great Blakenham, Ipswich, Suffolk IP6 0NL. Our main trading address is.
        Our VAT number is GB 573 8969 72.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We are a limited company under the laws of the UK and registered to do
        business in the U.S.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        To contact us, please email&nbsp;
        <a href="mailto:info@celestion.com">
          <span className="s4">info@celestion.com</span>
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>By using our site and app you accept these terms</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        BY USING OUR SITE AND APP, YOU CONFIRM THAT YOU ACCEPT THESE TERMS
        (TERMS OF USE) AND THAT YOU AGREE TO COMPLY WITH THEM. IF YOU DO NOT
        AGREE TO THESE TERMS OF USE, YOU MUST NOT USE OUR SITE.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We recommend that you print a copy of these Terms of Use for future
        reference.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>There are other terms that may apply to you</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        These Terms of Use refer to the following additional policies and terms,
        which also apply to your use of our site, the terms and conditions of
        which are incorporated herein, as applicable:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          Our&nbsp;
          <a href="privacy">
            <span className="s6">Privacy Policy</span>
          </a>
          , which sets out the terms on which we process any personal data we
          collect from you, or that you provide to us. By using our site, you
          consent to such processing and you warrant that all data provided by
          you is accurate.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Our&nbsp;
          <a href="acceptableUse">
            <span className="s6">Acceptable Use Policy</span>
          </a>
          , which sets out the permitted uses and prohibited uses of our site.
          When using our site, you must comply with this Acceptable Use Policy.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>We may make changes to these terms</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We amend these Terms of Use from time to time. We reserve the right, at
        our sole discretion, to change, modify, add or remove portions of these
        Terms of Use, at any time. Every time you wish to use our site, please
        check these Terms of Use to ensure you understand the Terms of Use that
        apply at that time. Your continued use of the site following the posting
        of changes will mean that you accept and agree to the changes. As long
        as you comply with these Terms of Use, We grant you a personal,
        non-exclusive, non-transferable, limited privilege to access and use our
        site.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>We may make changes to our site</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may update and change our site from time to time to reflect changes
        to our products, our users' needs and our business priorities. We will
        try to give you reasonable notice of any major changes, but are under no
        duty or obligation to do so and any changes or amendments to the site
        will be made in our sole and absolute discretion.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>We may suspend or withdraw our site</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">Our site is made available free of charge.</span>
    </p>
    <p className="p2">
      <span className="s1">
        We do not guarantee that our site, or any content on it, will always be
        available or be uninterrupted. We may suspend or withdraw or restrict
        the availability of all or any part of our site for business and
        operational reasons. We will try to give you reasonable notice of any
        suspension or withdrawal, but are under no duty or obligation to do so.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You are also responsible for ensuring that all persons who access our
        site through your internet connection are aware of the Terms of Use and
        other applicable terms and conditions, and that they comply with them.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Our site is only for users in the UK and the U.S.</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Our site is directed to people residing in the United Kingdom and the
        United States of America (U.S.). We do not represent that content
        available on or through our site is appropriate for use or available in
        other locations.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>You must keep your account details safe</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Certain features or services offered on the site may require you to open
        an account (including the setting up of a password or any other piece of
        information as part of our security procedure). You are entirely
        responsible for maintaining the confidentiality of the information on
        your account, including any password, and for any and all activity which
        occurs on your account. You must treat your account details as
        confidential and must not disclose them to any third party.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We have the right to disable any account or password, whether chosen by
        you or allocated by us, at any time, if in our reasonable opinion you
        have failed to comply with any of the provisions of the Terms of Use.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you know or suspect that anyone other than you knows your account
        details or password, or you suspect any other breach of security, you
        must notify us immediately at digitalinfo@celestion.com. You may be held
        liable for any losses incurred by us or any other user of or visitor to
        the site due to someone else using your account or password as a result
        of failing to keep such information secure and confidential.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Your account and password are personal to you. Do not provide access or
        allow or permit any third party to access your account or password.
        Similarly, you should not use anyone else&rsquo;s account or password.
        We cannot and will not be liable for any loss or damage arising from
        your failure to comply with these security obligations.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>How you may use material on our site</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We are the owner or the licensee of all intellectual property rights in
        our site, and in the material published on it. Those works are protected
        by copyright laws and treaties around the world. All such rights are
        reserved. Except as otherwise expressly provided for in the Terms of
        Use, no part of the site, including, but not limited to, any text,
        graphics, user or visual interfaces, photographs, trademarks, logos,
        sounds, music, artwork, computer code or any other materials or content
        of any kind (collectively, &ldquo;Content&rdquo;) may be copied,
        reproduced, republished, uploaded, downloaded, posted, publicly
        displayed, encoded, translated, transmitted or distributed in any way to
        any other computer, server, website, or device, or other medium of any
        kind for any reason, without our express prior written consent.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may use information on our site, and the products and services
        purposely made available by us to you, including for purchase, for
        downloading from the site provided that: 1) your use is for personal,
        non-commercial informational purposes, 2) any proprietary notice
        contained within such information is retained, 3) no modifications are
        made to any such information, products and services, and 4) you
        acknowledge, understand and agree that We make no warranties or
        representations regarding such information, products and services other
        than what is expressly provided in these Terms of Use or any other of
        policies or terms as incorporated herein.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        For the avoidance of doubt, you must not use any part of the content on
        our site for commercial purposes without obtaining a licence to do so
        from us or our licensors.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may not use any automatic device, algorithm or methodology or
        equivalent manual process to access, obtain, monitor or copy any part of
        our site or any of its Content, including any reproduction or bypassing
        of the structure or presentation of the site or any Content, so to
        obtain or attempt to obtain any materials, documents or information
        through any means nor purposely made available through the site. We
        expressly reserve our right to block any such activity.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Any violation of the terms and conditions of this section of the Terms
        of Use constitutes a material breach of these Terms of Use, and your
        right to use our site will cease immediately and you must, at our
        option, return or destroy any copies of the materials you copied,
        reproduced, republished, uploaded, downloaded, posted, publicly
        displayed, encoded, translated, transmitted or distributed in violation
        hereof.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may not use our site for any or any Content for any purpose that is
        unlawful or prohibited by these Terms of Use, or to solicit the
        performance of any illegal activity or other activity which infringes
        our rights or the rights of others.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Do not rely on information on this site</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        The content on our site is provided for general information only. It is
        not intended to amount to advice on which you should rely. You must
        obtain professional or specialist advice before taking, or refraining
        from, any action on the basis of the Content on our site.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Although we make reasonable efforts to update the information on our
        site, we make no representations, warranties or guarantees, whether
        express or implied, that the Content on our site is accurate, complete
        or up to date.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>We are not responsible for websites we link to</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Where our site contains links to other sites and resources provided by
        third parties, these links are provided for your information and/or
        convenience only. Such links should not be interpreted as approval by us
        of those linked websites or information you may obtain from them and we
        are not responsible for nor do we endorse the content of these other
        sites or resources.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We have no control over the contents of those sites or resources and you
        assume all risk by accessing and using any such third party sites.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>User-generated content is not approved by us</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        This website may include information and materials uploaded by other
        users of the site, including to bulletin boards and chat rooms. This
        information and these materials have not been verified or approved by
        us. The views expressed by other users on our site do not represent our
        views or values.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you wish to complain about information and materials uploaded by
        other users please contact us
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>
          Our responsibility for loss or damage suffered by you whether you are
          a consumer or a business user in the UK
        </strong>
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          We do not exclude or limit in any way our liability to you where it
          would be unlawful to do so. This includes liability for death or
          personal injury caused by our negligence or the negligence of our
          employees, agents or subcontractors and for fraud or fraudulent
          misrepresentation.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Different limitations and exclusions of liability will apply to
          liability arising as a result of the supply of any products to you,
          which will be set out in our terms and conditions of supply
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>If you are a business user in the UK:</strong>
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          We exclude all implied conditions, warranties, representations or
          other terms that may apply to our site or any content on it.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          We will not be liable to you for any loss or damage, whether in
          contract, tort (including negligence), breach of statutory duty, or
          otherwise, even if foreseeable, arising under or in connection with:
        </span>
      </li>
      <ul className="ul1">
        <li className="li3">
          <span className="s5">use of, or inability to use, our site; or</span>
        </li>
        <li className="li3">
          <span className="s5">
            use of or reliance on any content displayed on our site.
          </span>
        </li>
      </ul>
      <li className="li3">
        <span className="s5">In particular, we will not be liable for:</span>
      </li>
      <ul className="ul1">
        <li className="li3">
          <span className="s5">
            loss of profits, sales, business, or revenue;
          </span>
        </li>
        <li className="li3">
          <span className="s5">business interruption;</span>
        </li>
        <li className="li3">
          <span className="s5">loss of anticipated savings;</span>
        </li>
        <li className="li3">
          <span className="s5">
            loss of business opportunity, goodwill or reputation; or
          </span>
        </li>
        <li className="li3">
          <span className="s5">
            any indirect or consequential loss or damage.
          </span>
        </li>
      </ul>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>If you are a consumer user in the UK:</strong>
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          Please note that we only provide our site for domestic and private
          use. You agree not to use our site for any commercial or business
          purposes, and we have no liability to you for any loss of profit, loss
          of business, business interruption, or loss of business opportunity.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          If defective digital content that we have supplied, damages a device
          or digital content belonging to you and this is caused by our failure
          to use reasonable care and skill, we will either repair the damage or
          pay you compensation. However, we will not be liable for damage that
          you could have avoided by following our advice to apply an update
          offered to you free of charge or for damage that was caused by you
          failing to correctly follow installation instructions or to have in
          place the minimum system requirements advised by us.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>If you are a user in the U.S:</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        THE WARRANTIES SET FORTH IN THIS SECTION OF THESE TERMS OF USE
        CONCERNING THE SITE, ITS OPERATION AND FUNCTIONALITY, AND ITS CONTENT
        ARE EXCLUSIVE AND ARE IN LIEU OF ANY AND ALL OTHER WARRANTIES, EXPRESS
        OR IMPLIED.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        THE SITE IS PROVIDED &ldquo;AS IS&rdquo; WITHOUT ANY EXPRESS OR IMPLIED
        WARRANTY OF ANY KIND, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY,
        NON-INFRINGEMENT OF INTELLECTUAL PROPERTY, OR FITNESS FOR ANY PURPOSE OR
        WARRANTIES ARISING BY COURSE OF DEALING OR CUSTOM OR TRADE. WE MAKE NO
        WARRANTIES WITH RESPECT TO THE OPERATION, FUNCTION, PERFORMANCE AND
        AVAILABILITY OF THE SITE. WE DO NOT WARRANT THAT THE SITE WILL OPERATE,
        FUNCTION OR PERFORM UNINTERRUPTED OR &ldquo;BUG&rdquo; FREE, OR THAT THE
        FUNCTIONALITY OF VARIOUS ASPECTS OF THE SITE WILL MEET YOUR
        EXPECTATIONS.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        IN NO EVENT SHALL WE, OUR PARENTS, SUBSIDIARIES, AFFILIATES AND THEIR
        RESPECTIVE MEMBERS, DIRECTORS, OFFICERS, EMPLOYEES, STOCKHOLDERS AND
        AGENTS BE LIABLE TO YOU OR ANY OTHER ENTITY FOR ANY DAMAGES OF ANY KIND,
        INCLUDING, BUT NOT LIMITED TO DIRECT, COMPENSATORY, INDIRECT,
        INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES
        (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, BUSINESS
        INTERRUPTION, LOSS OF INFORMATION AND LOSS OF BUSINESS OPPORTUNITIES)
        ARISING OUT OF OR RELATING TO (1) YOUR USE OF OR INABILITY TO USE THE
        SITE, (2) RELIANCE ON ANY CONTENT APPEARING ON THE SITE; (3) ERRORS,
        INACCURACIES, OMISSIONS, DEFECTS, UNTIMELINESS, SECURITY BREACHES, (4)
        INFORMATION COMMUNICATED THROUGH CHAT ROOMS OR MESSAGE BOARDS, OR (5)
        ANY OTHER FAILURE OF THE SITE, INCLUDING ITS OPERATION, FUNCTION,
        PERFORMANCE AND AVAILABILITY, REGARDLESS OF WHETHER ANY SUCH CLAIM
        ARISING FROM YOUR ACCESS AND USE OF THE SITE IS BASED ON CONTRACT, TORT,
        STRICT LIABILITY, PRODUCT LIABILITY OR OTHERWISE, REGARDLESS OF WHETHER
        WE WERE ADVISED OF THE POSSIBILITY OF SUCH LOSES IN ADVANCE. WE SHALL
        NOT BE RESPONSIBLE FOR ANY COSTS OR DAMAGES ASSOCIATED WITH THE LOSS OF
        USE OF THE SITE OR ANY OTHER RESOURCES, LOSS OF BUSINESS OR PROFITS, ANY
        LOSS OF DATA, OR ANY THIRD PARTY CLAIMS. FURTHER, WE SHALL HAVE NO
        LIABILITY FOR ANY HARDWARD, SOFTWARE OR DATA STORED OR USED WITH THE
        SITE, INCLUDING THE COSTS OF REPAIRING, REPLACING OR RECOVERING SUCH
        HARDWARE, SOFTWARE OR DATA. Because some jurisdictions may not permit
        each of these disclaimers and limitations, the above limitation may not
        apply to you.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Uploading content to our site or app</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Whenever you make use of a feature that allows you to upload content to
        our site, or to make contact with other users of our site, you must
        comply with the content standards set out in our&nbsp;
        <a href="acceptableUse">
          <span className="s4">Acceptable Use Policy</span>
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You warrant that any such contribution does comply with those standards,
        and you will be liable to us and indemnify us for any breach of that
        warranty. This means you will be responsible for any loss or damage we
        suffer as a result of your breach of warranty, including from and
        against all losses, costs, damages, expenses, or liabilities as a result
        of, arising out of or in connection with a claim asserted by a third
        party against us as a result of your breach.
      </span>
    </p>
    <p className="p3">
      <span className="s5">
        Any content you upload to our site will be considered non-confidential
        and non-proprietary. You retain all of your ownership rights in your
        content, but you are required to grant us a royalty-free, perpetual,
        irrevocable, worldwide license to use, store and copy that content and
        to distribute and make it available to third parties. The rights you
        license to us are described in Rights you are giving us to use material
        you upload
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We also have the right to disclose your identity to any third party who
        is claiming that any content posted or uploaded by you to our site
        constitutes a violation of their intellectual property rights, or of
        their right to privacy.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We have the right to remove any posting you make on our site if, in our
        opinion, your post does not comply with the content standards set out in
        our&nbsp;
        <a href="acceptableUse">
          <span className="s4">Acceptable Use Policy</span>
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You are solely responsible for securing and backing up your content.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>
          DMCA Claims and Notices in the U.S. for Copyright Infringement
        </strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        The following section provides our process for receiving and handling
        claims in the U.S. for alleged copyright violations under the Digital
        Millennium Copyright Act of 1998 (the &ldquo;DMCA&rdquo;).
      </span>
    </p>
    <p className="p2">
      <span className="s6">
        Notification of Claims of Copyright Infringement.
      </span>
      <span className="s1">
        &nbsp;If you believe that any material on this site infringes upon any
        copyright you own or control, or that any link on this site directs
        users to another website containing material that infringes upon any
        copyright you own or control, you may file a notification of such
        infringement with our Designated Copyright Agent as set forth below.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Notice and Procedure for Notifying Designated Agent of Claims of
        Copyright Infringement. We will respond expeditiously to notices of
        alleged infringement that are reported to Company's Designated Agent.
        Contact Company&rsquo;s Designated Agent as follows:&nbsp;
        <a href="mailto:digitalinfo@celestion.com">
          <span className="s4">digitalinfo@celestion.com</span>
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you believe that your copyright has been infringed upon, please
        submit written notification to Company's Designated Agent as specified
        above and include the following:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          Identification of the copyrighted work claimed to have been infringed
          upon, or, if multiple copyrighted works at a single online site are
          covered by a single notification, a representative list of such works
          at that site.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Identification of the material that you're claiming has been infringed
          upon or to be the subject of infringing activity and that is to be
          removed or access to which is to be disabled, and information
          reasonably sufficient to permit us to locate the material.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Your full name, mailing address, telephone number, and, if available,
          e-mail address.
        </span>
      </li>
      <li className="li3">
        <span className="s5">Both of the following statements:</span>
      </li>
      <ul className="ul1">
        <li className="li3">
          <span className="s5">
            <em>
              "I hereby state that I have a good-faith belief that the disputed
              use of the copyrighted material is not authorized by the copyright
              owner, its agent, or the law (e.g. as a fair use)."
            </em>
          </span>
        </li>
        <li className="li3">
          <span className="s5">
            <em>
              "I hereby state that the information in this notification is
              accurate and, under penalty of lying under oath, that I am the
              owner, or authorized to act on behalf of the owner, of the
              copyright, or of an exclusive right under the copyright that is
              allegedly infringed."
            </em>
          </span>
        </li>
      </ul>
      <li className="li3">
        <span className="s5">
          Your full legal name and your electronic or physical signature.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s6">Infringer Policy</span>
      <span className="s1">
        . In accordance with the DMCA, the text of which may be found on the
        U.S. Copyright office website at:
      </span>
    </p>
    <p className="p4">
      <span className="s6">
        <a href="http://www.copyright.gov/legislation/dmca.pdf">
          http://www.copyright.gov/legislation/dmca.pdf
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        and other applicable law, we have adopted a policy of banning, in
        appropriate circumstances and at our sole discretion, users who are
        deemed to be repeat infringers. We may also, at our sole discretion,
        limit access to any website hosted by us and/or terminate the accounts
        of any users who infringe upon any intellectual property rights of
        others, whether there is any repeat infringement.
      </span>
    </p>
    <p className="p2">
      <span className="s6">Counter Infringement Policy</span>
      <span className="s1">
        . A poster of allegedly infringing material may make a
        counter-notification pursuant to Sections 512(g)(2) and 512(g)(3) of the
        DMCA. When we receive a counter-notification, we may, in our sole
        discretion, reinstate the material in question. To provide a
        counter-notification, please submit written notification to our
        Designated Agent as specified above and include the following:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          Identification of the material that has been removed or to which
          access has been disabled by us and the location at which the material
          appeared before it was removed or access was disabled.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          A statement as follows:&nbsp;
          <em>
            "I hereby state, under penalty of lying under oath, that I have a
            good-faith belief that the material was removed or disabled because
            of mistake of misidentification of the material to be removed or
            disabled."
          </em>
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Your full name, mailing address, telephone number, and, if available,
          e-mail address.
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          A statement as follows:&nbsp;
          <em>
            "I hereby consent to the authority of the Federal District Court for
            the judicial district in which the complaining party may be found,
            and I will accept service of process from the complaining party who
            notified GP Acoustics (UK) Limited of the alleged infringement or an
            agent of such person."
          </em>
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          Your full legal name and your electronic or physical signature.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>U.S. Government End Users.</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are affiliated with the U.S. government, then you should know
        that the software and documentation available on this Site is
        &ldquo;commercial items,&rdquo; as that term is defined in 48 C.F.R.
        2.101 (October 1995), consisting of &ldquo;commercial computer
        software&rdquo; and &ldquo;commercial computer software
        documentation,&rdquo; as such terms are used in 48 C.F.R. 12.212
        (September 1995). Consistent with 48 C.F.R. 12.212 and 48 C.F.R.
        227.7202-1 through 27.7202-4 (June 1995), all U.S. government end users
        acquire the software and documentation with only those rights set forth
        herein.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>
          We are not responsible for viruses and you must not introduce them
        </strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We do not guarantee that our site will be secure or free from bugs or
        viruses.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You are responsible for configuring your information technology,
        computer programmes and platform to access our site. You should use your
        own virus protection software.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You must not misuse our site by knowingly introducing viruses, trojans,
        worms, logic bombs or other material that is malicious or
        technologically harmful. You must not attempt to gain unauthorised
        access to our site, the server on which our site is stored or any
        server, computer or database connected to our site. You must not attack
        our site via a denial-of-service attack or a distributed denial-of
        service attack. By breaching this provision, you would commit a criminal
        offence under the Computer Misuse Act 1990. We will report any such
        breach to the relevant law enforcement authorities and we will
        co-operate with those authorities by disclosing your identity to them.
        In the event of such a breach, your right to use our site will cease
        immediately.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Rules about linking to our site and app</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may link to our home page, provided you do so in a way that is fair
        and legal and does not damage our reputation or take advantage of it.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You must not establish a link in such a way as to suggest any form of
        association, approval or endorsement on our part where none exists.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You must not establish a link to our site in any website that is not
        owned by you.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Our site must not be framed on any other site, nor may you create a link
        to any part of our site other than the home page.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We reserve the right to withdraw linking permission without notice.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        The website in which you are linking must comply in all respects with
        the content standards set out in our&nbsp;
        <a href="acceptableUse">
          <span className="s4">Acceptable Use Policy</span>
        </a>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you wish to link to or make any use of content on our site other than
        that set out above, please contact&nbsp;
        <a href="mailto:digitalinfo@celestion.com">
          <span className="s4">digitalinfo@celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Which country's laws apply to any disputes?</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are a consumer, please note that these terms of use, their
        subject matter and their formation, are governed by English law. You and
        we both agree that the courts of England and Wales will have exclusive
        jurisdiction except that if you are a resident of Northern Ireland you
        may also bring proceedings in Northern Ireland, and if you are resident
        of Scotland, you may also bring proceedings in Scotland.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are a business, these terms of use, their subject matter and
        their formation (and any non-contractual disputes or claims) are
        governed by English law. We both agree to the exclusive jurisdiction of
        the courts of England and Wales.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>Our trade marks are registered</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        The following trademarks are registered or pending registration in the
        U.S.:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s5">
          U.S. Registration No. 1039923 for CELESTION [standard character mark]
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          U.S. Registration No. 2129679 for CELESTION [stylized design]
        </span>
      </li>
      <li className="li3">
        <span className="s5">
          U.S. Serial No. 87225193 for CELESTION [standard character mark]
        </span>
      </li>
    </ul>
  </section>
);
